import React from 'react';
import axios from 'axios';
import { Button, FormGroup, Form, Input, FormFeedback } from 'reactstrap';
import SocialButtons from './socialButtons';
import Separator from './separator';
import { validateEmail, confirmPasswordMatch, validatePasswordLength, checkIfUserExists } from '../validation/validateElements';
import LoaderElement from '../../chrome/elements/icons/loaderElement';
import Cookies from "../../../util/cookies";
import {captureException} from "../../../util/sentry";

const buttonStyle = {
	padding: '0.75rem',
};

export default class SignupBase extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			emailOpen: false,
			email: '',
			session: this.props.session,
			password: '',
			password2: '',
			passwordValid: {},
			passwordFeedback: '',
			emailValid: {},
			emailFeedback: '',
			passwordMatch: {},
			passwordMatchFeedback: '',
			loading: false,
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handlePassword2Change = this.handlePassword2Change.bind(this);
	}
	toggleEmail = () => {
		this.setState({
			emailOpen: !this.state.emailOpen,
		});
	};
	handleEmailChange(event) {
		this.setState({
			email: event.target.value.trim(),
			session: this.state.session,
		});
	}
	handlePasswordChange(event) {
		this.setState({
			password: event.target.value.trim(),
			session: this.state.session,
		});
	}

	handlePassword2Change(event) {
		this.setState({
			password2: event.target.value.trim(),
			session: this.state.session,
		});
	}

	validateAll() {
		if (!validateEmail(this.state.email)) {
			this.setState({ emailValid: { valid: false }, emailFeedback: 'Please enter valid email address', loading: false });
			return false;
		}
		this.setState({ emailValid: { valid: true }, emailFeedback: '' });

		if (!validatePasswordLength(this.state.password)) {
			this.setState({ passwordValid: { valid: false }, passwordFeedback: 'Password must be at least 8 characters long', loading: false });
			return false;
		}
		this.setState({ passwordValid: { valid: true }, passwordFeedback: '' });

		if (!confirmPasswordMatch(this.state.password, this.state.password2)) {
			this.setState({ passwordMatch: { valid: false }, passwordMatchFeedback: 'Passwords do not match. Please try again.', loading: false });
			return false;
		}
		this.setState({ passwordMatch: { valid: true }, passwordMatchFeedback: '' });

		return true;
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({
			loading: true,
		});

		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEvent('signupInitiated', {method: 'email-password'}, {amplitude: true});
		}

		try {
			const self = this;
			const data = new FormData();
			data.append('email', this.state.email);
			data.append('password', this.state.password);
			if (this.validateAll()) {
				checkIfUserExists(this.state.email).then((response) => {
					if (response === null) {
						axios({
							method: 'post',
							url: `/signup`,
							data: {
								email: this.state.email,
								password: this.state.password,
								_csrf: this.props._csrf,
							},
						})
							.then((response) => {
								const eventData = {
									content_name: "user-registration",
									status: true
								};

								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEvent('CompleteRegistration', eventData, {fbPixel: true});
								}

								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEventSync('signupSuccess', {method: 'email-password'}, {amplitude: true});
								}
								//this.props.toggle();
								window.location.reload();
							}).catch(err => {
								captureException(err, {});
								self.setState({
									emailFeedback: 'Something went wrong. Please try again later!',
									loading: false
								});
							});
					} else {
						this.setState({ emailValid: { valid: false }, emailFeedback: 'You seem to be an existing user. Please log in.', loading: false });

						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEvent('signupFailed', {method: 'email-password', reason: 'existing-user'}, {amplitude: true});
						}
					}
				}).catch(() => {
					this.setState({ emailValid: { valid: false }, emailFeedback: 'You seem to be an existing user. Please log in.', loading: false });

					if (window.eventDispatcher) {
						window.eventDispatcher.dispatchEvent('signupFailed', {method: 'email-password', reason: 'existing-user'}, {amplitude: true});
					}
				});
			}
		} catch (err) {
		}
	};

	onGoogleButtonClick = (e) => {
		Cookies.save('redirect_url', window.location.href);
		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEvent('loginInitiated', {method: 'google'}, {amplitude: true});
		}
		return true;
	};

	onFacebookButtonClick = (e) => {
		Cookies.save('redirect_url', window.location.href);
		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEvent('loginInitiated', {method: 'facebook'}, {amplitude: true});
		}
		return true;
	};

	render() {
		if (this.state.emailOpen) {
			return (
				<div style={{ width: '100%' }}>
					<div style={{ textAlign: 'center', width: '100%' }}>
						<p style={{ color: '#666666', margin: '0' }}> Sign Up with <a className="secondary-a" href="/auth/oauth/facebook" onClick={this.onFacebookButtonClick}><span className="secondary-color">Facebook </span></a> or <a className="secondary-a" href="/auth/oauth/google" onClick={this.onGoogleButtonClick}><span className="secondary-color">Google </span></a> </p>
					</div>
					<Separator />
					<Form id="signup" method="post" action="/signup">
						<FormGroup style={{ width: '100%' }}>
							<Input autoFocus {...this.state.emailValid} type="email" name="email" id="email" placeholder="Email Address" value={this.state.email} onChange={this.handleEmailChange} />
							<FormFeedback style={{ display: 'block' }}>{this.state.emailFeedback}</FormFeedback>
						</FormGroup>
						<FormGroup style={{ width: '100%' }}>
							<Input {...this.state.passwordValid} type="password" name="password" id="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} />
							<FormFeedback style={{ display: 'block' }}>{this.state.passwordFeedback}</FormFeedback>
						</FormGroup>
						<FormGroup style={{ width: '100%' }}>
							<Input {...this.state.passwordMatch} type="password" name="password2" id="password2" placeholder="Confirm Password" value={this.state.password2} onChange={this.handlePassword2Change}	 />
							<FormFeedback style={{ display: 'block' }}>{this.state.passwordMatchFeedback}</FormFeedback>
						</FormGroup>
						<div style={{
							marginTop: '1rem', marginBottom: '1rem', width: '100%', textAlign: 'center',
						}}
						>
							<Button
								disabled={this.state.loading}
								color="primary"
								className="btn-full-width"
								style={buttonStyle}
								type="submit"
								onClick={this.handleSubmit}
								>
								{this.state.loading ?
										<LoaderElement
											color="#FFFFFF"
											size="20"
											style={{
												paddingRight: '5px'
											}}
										/> : ''}Sign Up </Button>
							<p style={{ fontSize: '0.875rem', paddingTop: '0.5rem' }}> By signing up, you agree to our <a className="secondary-a" href="/terms" rel="noopener noreferrer" target="_blank"><span className="secondary-color">terms of use</span></a>, <a className="secondary-a" href="/privacy" rel="noopener noreferrer" target="_blank"><span className="secondary-color">privacy policy</span></a> and <a className="secondary-a" href="/privacy" rel="noopener noreferrer" target="_blank"><span className="secondary-color">cookie policy</span></a> </p>
						</div>
					</Form>
				</div>

			);
		}
		return (
			<div style={{ width: '100%' }}>
				<SocialButtons text="Sign Up" />
				<Separator />
				<div style={{ marginTop: '1rem', marginBottom: '1rem', width: '100%' }}>
					<Button color="dark" className="btn-full-width" style={buttonStyle} onClick={() => this.toggleEmail()}> Sign Up with Email </Button>
				</div>
			</div>
		);
	}
}
